import { Locale } from 'date-fns';
import i18n from 'i18next';
import * as dateFnsLocales from 'date-fns/locale';

export class LocaleUtil {

  private static dateFnsLocaleMap = Object.values(dateFnsLocales).reduce((acc, locale) => {
    if (locale && locale.code) {
      return acc.set(locale.code, locale);
    }
    return acc;
  }, new Map<string, Locale>());

  static getRootLanguageCodeFromLocaleString(localString: string): string {
    return localString.split(/[-_]/)[0];
  }

  static getDateFnsLocale(language?: string): Locale {
    if (!language) {
      language = i18n.language;
    }
    if (!language) {
      return dateFnsLocales.enUS;
    }

    return (
      LocaleUtil.dateFnsLocaleMap.get(language) ||
      LocaleUtil.dateFnsLocaleMap.get(
        LocaleUtil.getRootLanguageCodeFromLocaleString(language),
      ) ||
      dateFnsLocales.enUS
    );
  }

  static getTimezone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
